<template>
  <div class="decoration-config">
    <card-tips
      class="decoration-config__tip"
      left-title="企业仅支持对企业资料及整体样式进行编辑"
      right-title="公司基础信息设置"
      @on-click="handleOnSettingClick"
    >
    </card-tips>
    <div class="decoration-config-content">
      <div class="decoration-config-tabs">
        <el-tabs
          v-model="activeTab"
          @tab-click="handleOnTabClick"
        >
          <mk-tab-pane
            label="名片设置"
            name="nameCardSetting"
          >
            <decoration-config-collapse
              :components-map="componentsMap"
              :data="nameCardList"
              :active="active"
              @on-active-click="handleOnActiveClick"
              @on-new-click="handleOnNewClick"
              @on-delete-click="handleOnDeleteClick"
              @on-radio-change="handleOnRadioChange"
              @on-save-title-click="handleOnSaveTitleClick"
            >
            </decoration-config-collapse>
          </mk-tab-pane>
          <mk-tab-pane
            label="商品设置"
            name="goodsSetting"
          >
            <decoration-config-collapse
              :components-map="componentsGoodsSettingMap"
              :data="nameCardList"
              :active="active"
              @on-active-click="handleOnActiveClick"
              @on-new-click="handleOnNewClick"
              @on-delete-click="handleOnDeleteClick"
              @on-radio-change="handleOnRadioChange"
            >
            </decoration-config-collapse>
          </mk-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div
      class="decoration-config__bottom"
    >
      <mk-button-biz
        height="32px"
        type="primary"
        class="decoration-config__bottom__save"
        @click="handleOnSaveClick"
      >
        保存
      </mk-button-biz>
    </div>
    <mk-drawer-biz-two
      :visible="visible"
      size="820px"
      :before-close="handleBeforeClose"
      :class="{'link-tip-style':isShowLinkTips}"
      @close="handleOnDrawerCloseClick"
    >
      <!-- header 头部区域 -->
      <template slot="title">
        <span class="drawer-biz-title">{{ '新增' + title }}
          <mk-popover
            placement="right"
            trigger="hover"
          >
            <p>
              {{ activeIcon.message }}
            </p>
            <i
              v-if="activeIcon.show"
              slot="reference"
              class="el-icon-warning"
            >
            </i>
          </mk-popover>
        </span>
      </template>

      <!-- 宣传册、营销视频、营销资料 跳转外链提示 -->
      <card-tips
        v-show="isShowLinkTips"
        class="decoration-show-link__tip"
        :left-title="`小程序中无法正常显示存在外链的${title}，请谨慎添加`"
      >
        <div
          slot="right"
          class="view-example-content"
        >
          <mk-popover
            popper-class="view-example-content__popover"
            placement="bottom"
            trigger="hover"
          >
            <div>
              <p>小程序不支持外链的跳转，示例如图</p>
              <img src="../../images/smartCardLinkTips.png">
            </div>
            <span
              slot="reference"
              class="cursor"
            >查看示例</span>
          </mk-popover>
        </div>
      </card-tips>

      <!-- 中间区域 -->
      <list-biz
        v-if="visible"
        v-loading="loading"
        class="decoration-config-biz__table"
        :config="config"
        :data="data"
        :total="total"
        :page="params.page"
        :infinite-scroll-disabled="infiniteScrollDisabled"
        @on-current-change="handleOnCurrentChange"
        @on-search-change="hanldeOnSearchClick"
        @on-type-change="handleOnTypeChange"
        @on-select-change="handleOnSelectChange"
        @on-load-change="handleOnLoadChange"
        @on-reset-click="handleOnResetChange"
      >
      </list-biz>
      <!-- 底部操作 -->
      <template
        slot="bottom"
      >
        <mk-button
          size="small"
          @click="handleOnCancelClick"
        >
          取消
        </mk-button>
        <mk-button
          size="mini"
          type="primary"
          @click="handleOnAddClick"
        >
          添加
        </mk-button>
      </template>
    </mk-drawer-biz-two>
    <company
      v-if="visibleCompanySetting"
      :visible="visibleCompanySetting"
      :data="nameCardList"
      @close="handleOnCompanyClose"
    >
    </company>
  </div>
</template>

<script>
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'
import configComponents from '@views/smart-name-card/name-card-decoration/components/decoration-config/components/index.js'
import { BIZAPIS, CARDAPIS, MKMATERIALSVC } from '@api'
export default {
  name: 'DecorationConfig',
  components: { MkDrawerBizTwo },
  data () {
    return {
      componentsMap: configComponents.componentsNameCardMap,
      componentsGoodsSettingMap: configComponents.componentsGoodsSettingMap,
      active: 'cardStyle',
      visible: false,
      title: '',
      config: {},
      data: [],
      params: {
        page: 1,
        pageSize: 10,
        showTags: true,
        tags: [],
        title: '',
        name: '',
        fileType: 0,
        materialType: 0,
        status: 1 // 已发布
      },
      total: 0,
      section: [],
      // 保存装修数据参数
      nameCardParams: {
        brochures: [],
        cardStyle: '',
        cases: [],
        documents: [],
        materials: [],
        pictures: [],
        posters: [],
        materialVideos: [],
        ordinaryVideos: [],
        goods: []
      },
      nameCardList: {},
      visibleCompanySetting: false,
      activeTab: 'nameCardSetting',
      loading: false,
      infiniteScrollDisabled: false
    }
  },
  computed: {
    activeIcon () {
      if (this.active !== '' && this.activeTab === 'nameCardSetting') {
        return {
          show: this.componentsMap[this.active].icon ? this.componentsMap[this.active].icon.show : false,
          message: this.componentsMap[this.active].icon ? this.componentsMap[this.active].icon.message : ''
        }
      } else {
        return {
          show: false,
          message: ''
        }
      }
    },
    // 是否展示外链跳转提示  宣传册、营销视频、营销资料 展示
    isShowLinkTips () {
      if (this.visible && (this.config.params.type === 'article' || this.config.params.type === 'form' || this.config.params.type === 'h5' || this.config.params.type === 'brochure' || this.config.params.type === 'video-markting')) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    // this.companyCardDetailGet()
    this.getSettingsDetail()
  },
  methods: {
    handleOnActiveClick (active) {
      this.active = active
      this.$emit('on-active-click', active)
    },
    async handleOnNewClick (item) {
      this.visible = true
      this.title = this._.cloneDeep(item.defaultTitle)
      this.config = this._.cloneDeep(item)
      // 图片接口参数
      if (this.config.params.type === 'picture') {
        this.params.fileType = 6
      }
      if (this.config.params.type === 'ordinaryVideo') {
        this.params.fileType = 8
      }
      this.params.page = 1
      if (this.config.mode !== 'image') {
        this.getListBizData(this.ajaxMap(this.config.params.type), this.params, false)
      }
    },
    // 翻页事件
    handleOnCurrentChange (value) {
      this.params.page = value
      this.getListBizData(this.ajaxMap(this.config.params.type), this.params, false)
    },
    // 滚动加载事件
    handleOnLoadChange () {
      this.getListBizData(this.ajaxMap(this.config.params.type), this.params, true)
    },
    hanldeOnSearchClick (params) {
      this.search(params)
    },
    handleOnResetChange (params) {
      this.search(params)
    },
    search (params) {
      this.params = {
        ...this.params,
        ...params
      }
      // 搜索强制重置为 1
      this.params.page = 1
      // 参数处理
      const type = this.config.params.type
      if (type === 'file') {
        this.params.materialType = params.select || 0
      }
      if (type === 'picture' || type === 'ordinaryVideo' || type === 'video-markting' || type === 'good') {
        this.params.name = params.title
      }
      let load = false
      if (type === 'picture') {
        load = true
      }
      this.data = []
      // 这里还要区分下类型
      this.getListBizData(this.ajaxMap(this.config.params.type), this.params, load)
    },
    handleOnTypeChange (type) {
      this.params.page = 1
      this.config.params.type = type
      if (type === 'picture') {
        this.params.fileType = 6
        this.params.name = name
      } else if (type === 'ordinaryVideo') {
        this.params.fileType = 8
        this.params.name = name
      } else {
        this.params.fileType = 0
        this.params.name = ''
      }
      this.section = []
      this.data = []
      if (this.config.mode === 'table') {
        this.getListBizData(this.ajaxMap(type), this.params, false)
      } else {
        this.infiniteScrollDisabled = false
      }
    },
    handleOnSelectChange (section) {
      this.section = section
    },
    handleOnDeleteClick (data) {
      // 第一步，删除配置数据信息
      this.deleteConfigData(data, this.active)
      // 第二步，更新预览数据
      this.$emit('on-change', {
        active: this.active,
        data: this.nameCardList[this.active]
      })
    },
    handleOnRadioChange (value) {
      this.nameCardList.cardStyle = value
      this.$emit('on-change', {
        active: this.active,
        data: this.nameCardList[this.active]
      })
    },
    handleOnSaveTitleClick (item) {
      this.componentsMap[item.name].title = item.title
      this.$emit('on-title-change', {
        name: this.active,
        title: item.title
      })
    },
    ajaxMap (type) {
      const map = {
        'article': MKMATERIALSVC.ArticleApi.articleFindForCardPost,
        'h5': MKMATERIALSVC.H5Api.h5ListPost,
        'form': BIZAPIS.FormApi.materialFormIndexPost,
        'poster': MKMATERIALSVC.PosterApi.posterPost,
        'picture': MKMATERIALSVC.OrdinaryApi.ordinaryListPostPost,
        'brochure': MKMATERIALSVC.BrochureApi.brochureListPost,
        'case': MKMATERIALSVC.CaseApi.caseFindListPost,
        'ordinaryVideo': MKMATERIALSVC.OrdinaryApi.ordinaryListPostPost,
        'video-markting': MKMATERIALSVC.VideoApi.videoListPost,
        'file': MKMATERIALSVC.MiniMaterialApi.miniMaterialListPost,
        'good': MKMATERIALSVC.GoodApi.goodFindListPost
      }
      return map[type]
    },
    handleBeforeClose () {
    },
    handleOnDrawerCloseClick () {
      this.data = []
      this.infiniteScrollDisabled = false
      this.visible = false
    },
    handleOnCompanyClose () {
      this.companyCardDetailGet()
      this.visibleCompanySetting = false
    },
    handleOnSettingClick () {
      this.visibleCompanySetting = true
    },
    handleOnAddClick () {
      // 这里暴露出添加的数据,同步到预览页面
      // this.$emit('on-add-click', {})
      // this.visible = false
      // 1. 提示当前选择数据是否超出条数限制，超出则不保存，提示用户取消多余选择
      // 2. 若有重复的选择，则进行合并
      // 将当前数据与新添加数据进行合并
      let type = this.config.params.type
      let section = this.addTypeToImage(this.section, type)
      let data = this.getUniqList(this.nameCardList[this.active].concat(section))
      let len = data.length
      let limit = 0
      if (this.activeTab === 'goodsSetting') {
        limit = this.componentsGoodsSettingMap[this.active].limit
      } else {
        limit = this.componentsMap[this.active].limit
      }
      if (len <= limit) {
        // 这里要对图片，海报（active）进行特殊处理，增加 type 字段
        this.nameCardList[this.active] = data
        this.$emit('on-change', {
          active: this.active,
          data
        })
        this.visible = false
        this.section = []
      } else {
        this.$message.error(`您最多只能添加${limit}个！`)
      }
    },
    handleOnCancelClick () {
      this.visible = false
      // 重置数据
    },
    handleOnSaveClick () {
      let params = this.getNameCardParams(this.nameCardList)
      this.companyCardMaterialUpdatePost(params)
    },
    handleOnTabClick () {
      if (this.activeTab === 'goodsSetting') {
        this.active = 'goods'
      } else {
        this.active = 'cardStyle'
      }
      this.$emit('on-tab-click', this.activeTab)
    },
    // 获取页面数据
    async getListBizData (func, queryParams, load) {
      // 这里进行数据处理，返回数据
      this.loading = true
      const { success, data: { data, list, total, count }, msg } = await func(queryParams)
      if (success) {
        // 无限加载与翻页事件
        // 对 image 返回数据进行处理
        const type = this.config.params.type
        let currentList = this.transformMap(data || list)
        if (load) {
          if (currentList.length < this.params.pageSize) {
            this.infiniteScrollDisabled = true
          } else {
            this.params.page++
            this.infiniteScrollDisabled = false
          }
          this.data = this.data.concat(currentList)
        } else {
          this.data = currentList
          this.total = total || count
        }
        this.loading = false
      } else {
        this.$message.error(msg)
      }
    },
    // 获取名片详情数据
    async companyCardDetailGet () {
      const { success, data, msg } = await CARDAPIS.CardApi.companyCardDetailGet()
      if (success) {
        this.nameCardList = this.transformCardList(data)
      } else {
        this.$message.error(msg)
      }
    },
    async getSettingsDetail () {
      const res = await Promise.all([
        CARDAPIS.CardApi.companyCardDetailGet(),
        CARDAPIS.CardApi.companyCardGoodsDetailGet(),
        CARDAPIS.CardApi.companyCardGetCardConfigGet({ configType: 'card' })
      ])
      if (res[0].success && res[1].success) {
        let data = {
          ...res[0].data,
          goods: res[1].data
        }
        this.nameCardList = this.transformCardList(data)
        this.componentsMap = this.mergeComponentsMap(this.componentsMap, res[2].data)
      }
    },
    async companyCardMaterialUpdatePost (params) {
      const { success, msg } = await CARDAPIS.CardApi.companyCardMaterialUpdatePost(params)
      if (success) {
        this.$message.success('保存名片信息成功！')
      } else {
        this.$message.error(msg)
      }
    },
    transformMap (data) {
      let list = []
      data.forEach(item => {
        if (item.url) {
          item.cover = item.url
        }
        if (item.cover) {
          item.url = item.cover
        }
        if (item.name) {
          if (this.config.params) {
            const type = this.config.params.type
            if (type !== 'form') item.title = item.name
          }
        }
        if (item.id) {
          item._id = item.id
        }
        // 商品封面图处理
        if (item.carouselPicture) {
          if (item.carouselPicture.length > 0) {
            item.cover = item.carouselPicture[0].url || ''
          }
          // 这里字段有重复，先这样处理
          item.type = 'good'
        }
        list.push(item)
      })
      return list
    },
    transformCardList (nameCardList) {
      for (const key in nameCardList) {
        if (nameCardList.hasOwnProperty(key) && nameCardList[key] instanceof Array) {
          nameCardList[key] = this.transformMap(nameCardList[key])
        }
      }
      return nameCardList
    },
    mergeComponentsMap (components, data) {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          components[key].title = data[key].title
        }
      }
      return components
    },
    getIds (currentSelection, section) {
      let sectionIds = []
      section.forEach(item => {
        sectionIds.push(item._id)
      })
      // 去重
      return Array.from(new Set(sectionIds.concat(currentSelection)))
    },
    deleteConfigData (data, name) {
      let currentConfig = this.nameCardList[name]
      let index = this._.findIndex(currentConfig, data)
      currentConfig.splice(index, 1)
    },
    getNameCardParams (nameCardList) {
      let nameCardParams = {}
      for (const key in nameCardList) {
        if (nameCardList.hasOwnProperty(key) && nameCardList[key] instanceof Array) {
          const element = nameCardList[key]
          let ids = []
          // 这里的图片参数命名与视频命名共用参数，这里需要重构下，要是有三个还是需要更改代码
          let imageIds = []
          let posterIds = []
          // 图片、视频排序数组
          let imagesOrder = []
          let videosOrder = []
          element.forEach(item => {
            const id = item._id ? item._id : item.id
            if (key === 'images') {
              if (item.type === 'picture') {
                imageIds.push(id)
              } else {
                posterIds.push(id)
              }
              imagesOrder.push(id)
            } else if (key === 'videos') {
              if (item.type === 'ordinaryVideo') {
                imageIds.push(id)
              } else {
                posterIds.push(id)
              }
              videosOrder.push(id)
            } else {
              ids.push(id)
            }
          })
          if (key === 'images') {
            nameCardParams['pictures'] = imageIds
            nameCardParams['posters'] = posterIds
            nameCardParams['imagesOrder'] = imagesOrder
          } else if (key === 'videos') {
            nameCardParams['ordinaryVideos'] = imageIds
            nameCardParams['materialVideos'] = posterIds
            nameCardParams['videosOrder'] = videosOrder
          }
          nameCardParams[key] = ids
        } else {
          nameCardParams[key] = nameCardList[key]
        }
      }
      return nameCardParams
    },
    getCurrentSelectedNumber (active) {
      const currentList = this.nameCardList[active] ? this.nameCardList[active] : []
      return currentList.length
    },
    getUniqList (list) {
      let curList = this._.cloneDeep(list)
      return this._.uniqWith(curList, (arrVal, othVal) => {
        return arrVal._id === othVal._id
      })
    },
    addTypeToImage (data, type) {
      let list = []
      data.forEach(item => {
        item.type = type
        list.push(item)
      })
      return list
    }
  }
}
</script>
<style lang="scss" scoped>
.decoration-config {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .decoration-config-content {
    flex: 1;
    overflow: auto;
    padding-bottom: 56px;
    background-color: #fff;
    color: #262626;

    .el-collapse {
      /deep/.el-icon-arrow-right {
        display: none;
      }

      /deep/.el-collapse-item__header {
        height: 44px;
      }

      /deep/.el-collapse-item__content {
        padding-bottom: 10px;
      }
    }

    .el-tabs {
      /deep/.el-tabs__header {
        margin: 0;
      }

      /deep/.el-tabs__nav-wrap::after {
        height: 1px;
      }
    }

    /deep/ .el-tabs__nav-scroll {
      .el-tabs__item {
        height: 46px;
        line-height: 46px;
        padding: 0 26px;
        font-weight: 500;
      }

      .el-tabs__item.is-active {
        color: #009cff !important;
      }

      .el-tabs__active-bar {
        background: #009cff !important;
      }
    }

    /deep/ .el-tabs__active-bar {
      padding: 0 10px;
      margin-left: -10px;
    }

    /deep/ .el-tabs__nav-wrap {
      padding: 0 !important;
    }

    .decoration-config__collapse {
      .collapse-biz__new {
        float: right;
      }

      .decoration-config__collapse__title {
        width: 100%;
        height: 44px;
        line-height: 44px;
        padding: 0 12px;

        .el-icon-plus {
          margin-right: 4px;
        }
      }

      .decoration-config__collapse__title:hover {
        background-color: #f7f7f7;
      }
    }
  }

  .decoration-config__tip {
    margin: 12px 12px 0 12px;
  }

  .decoration-config__bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .decoration-config__bottom__save {
      margin-top: 12px;
      margin-right: 12px;
    }
  }

  .mk-drawer-biz-two-content {
    position: relative;

    /deep/.el-pagination {
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}

.drawer-biz-title {
  font-weight: 500;
}

.el-icon-warning {
  margin-left: 5px;
  color: #1890ff;
  font-size: 12px;
}

.list-biz {
  /deep/.el-table th:first-child {
    .el-checkbox {
      display: none;
    }
  }
}

.decoration-show-link__tip {
  position: absolute;
  top: 10px;
  left: 20px;
  right: 20px;

  .view-example-content {
    text-align: right;
    padding-right: 12px;

    span {
      color: #009cff;
    }
  }
}

.view-example-content__popover {
  p {
    color: #595959;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 8px;
  }

  img {
    width: 210px;
    height: auto;
  }
}

.link-tip-style {
  /deep/ .el-drawer__container {
    .el-drawer__body {
      .drawer-content {
        position: relative;
        padding-top: 58px;
      }
    }
  }
}
</style>
